var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TextCell lighten-4",on:{"click":_vm.handleClick}},[(_vm.linkTo.length > 0)?_c('router-link',{attrs:{"to":_vm.linkTo}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):[_vm._v(" "+_vm._s(_vm.text)+" ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }